import * as Yup from "yup";

export const forgottenPasswordValidationSchema = Yup.object().shape({
	email: Yup.string("Email is required")
		.email("Invalid email")
		.required("Email is required"),
});
